module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Acknowledgements-rw exclude-auto-rw page-open-right-rw",
    attrs: {
      "epub:type": "frontmatter",
      "id": "Acknowledgements1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block4"
    }
  }, [_c('h1', {
    attrs: {
      "id": "h14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p21"
    }
  }, [_vm._v("This book was a long time in the making, and it wouldn’t have happened without the love, support, and encouragement of so many people.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p22"
    }
  }, [_vm._v("First and foremost I would like to thank my family for supporting my dream of being a published author. Thank you to my husband, Graham, my parents, Cathy and Gerry, my brother, Wes, and my extended family, as well as my in-laws, for your love, support, and continued enthusiasm. A huge thank-you to my sister-in-law Samantha Wyatt for being one of the first people to read the book and to cheer me on, and to Joan Wyatt, who was one of my earliest fans, and who is missed every single day. A special shout-out to my dog Schroeder, who endured many walk-less days and was by my side almost constantly while I wrote.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p23"
    }
  }, [_vm._v("I’d also like to thank my best friends, the Thursday Girls—Amanda, Robin, and Sarah—for putting up with months of neglect, whining, and me going on and on about made-up people. You guys are awesome, and I’m lucky to have such amazing girlfriends.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p24"
    }
  }, [_vm._v("A special thanks to my fantastic critique partners, Erin Moore and Harper St. George, without whom this book would’ve been impossible to finish. I’m so incredibly lucky to work with you talented, smart, amazingly supportive ladies.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p25"
    }
  }, [_vm._v("Thank you to my agent, Jessica Watterson, for believing in me and my writing, and for helping to make my dreams come true. Thanks to my editors, Lauren Plude and Alex Logan, for all your hard work. The book wouldn’t be what it is without you. And thank you to my Hamilton Public Library coworkers, who have cheered me on tirelessly from day one.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("I have made so many amazing friends while writing this book, and I feel so incredibly fortunate to have people like Jenn Burke, Kelly Jensen, Kelly Siskind, Brenna Mills, Amanda Heger, and many others in my corner. Twitter friends "), _c('i', [_vm._v("are")]), _vm._v(" real friends! I would especially like to thank Shannon Richard—you are a new friend, an awesome friend, and a keeper. I’m so glad to know you.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("Finally a huge, enormous, elephant-size thank-you to the Toronto Romance Writers, especially the wonderful, lovely, and talented Juliana Stone. I would not be where I am today without your kindness and support. You are amazing, and I’m lucky to know you. I would also like to thank Morgan Rhodes, Eve Silver, Molly O’Keefe, Maureen McGowan, and Nicki Pau Preto (who gets me like WHOA—I love you, bae).")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p28"
    }
  }, [_vm._v("Oh, and wine. Can’t ever forget the wine.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c58f461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s005-Acknowledgements-01.vue
// module id = 72
// module chunks = 0